<template>
  <v-app>
    <div class="container-herohire">
      <h2>
        Your Dashboard.
      </h2>
      <p class="white--text">
        We are currently building a shiny new dashboard for you.
      </p>
      <div class="d-flex justify-center">
        <v-row>
          <v-col md="6">
<!--            <router-link to="payments">-->
<!--              <button class="button button-primary button-shadow button-block button-glow">-->
<!--                Payments-->
<!--              </button>-->
<!--            </router-link>-->
          </v-col>
        </v-row>

      </div>

    </div>

    <DashboardFooter/>
  </v-app>
</template>

<script>
import DashboardFooter from '@/components/Dashboard/DashboardFooter';

export default {
  name: "Dashboard",
  components: {DashboardFooter},
  data() {
    return {
      auth: ''
    }
  },
  mounted() {
    this.auth = this.$firebase.auth();

    if (!this.$store.getters.user.loggedIn) {
      console.error('NOT LOGGED IN')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>

</style>
